import { render } from "./PlaylistChooser.vue?vue&type=template&id=3b391b77&scoped=true"
import script from "./PlaylistChooser.vue?vue&type=script&lang=js"
export * from "./PlaylistChooser.vue?vue&type=script&lang=js"

import "./PlaylistChooser.vue?vue&type=style&index=0&id=3b391b77&scoped=true&lang=css"

import exportComponent from "/home/tamo/projects/wedio/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b391b77"]])

export default __exports__